import isEqual from 'lodash/isEqual';

const getOrigin = (bound) => bound.segments[0].origin;

const getDestination = (bound) => bound.segments[bound.segments.length - 1].destination;

const isReturnTrip = (bounds) => {
  if (bounds.length !== 2) {
    return false;
  }
  const outBoundOrigin = getOrigin(bounds[0]);
  const outBoundDestination = getDestination(bounds[0]);
  const inBoundOrigin = getOrigin(bounds[1]);
  const inBoundDestination = getDestination(bounds[1]);
  return isEqual(outBoundOrigin, inBoundDestination) && isEqual(outBoundDestination, inBoundOrigin);
};

const transformToCartFlightInfo = (bound) => ({
  origin: getOrigin(bound),
  destination: getDestination(bound),
});

export const transformToCartFlightInfoItems = (bounds = []) =>
  isReturnTrip(bounds)
    ? [transformToCartFlightInfo(bounds[0])]
    : bounds.map(transformToCartFlightInfo);
